import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _parseFloat from "@babel/runtime-corejs3/core-js-stable/parse-float";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/jsx-no-bind,no-prototype-builtins */
import React from 'react';
import types from 'prop-types';
import ReactDOM from 'react-dom';
import { nonNegativeInteger } from 'airbnb-prop-types';
import moment from 'moment';
import throttle from 'lodash/throttle';
import isTouchDevice from 'is-touch-device';
import { styled } from '@rexlabs/styling';
import styles from '../styles/day-picker';
import { DayPickerKeyboardShortcutsPhrases, DayPickerNavigationPhrases } from '../defaultPhrases';
import getPhraseTypes from '../utils/getPhrasePropTypes';
import OutsideClickHandler from './outside-click-handler';
import CalendarMonthGrid from './calendar-month-grid';
import DayPickerNavigation from './day-picker-navigation';
import DayPickerKeyboardShortcuts, { TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT } from './day-picker-keyboard-shortcuts';
import getTransformStyles from '../utils/getTransformStyles';
import getCalendarMonthWidth from '../utils/getCalendarMonthWidth';
import getActiveElement from '../utils/getActiveElement';
import isDayVisible from '../utils/isDayVisible';
import ScrollableOrientationShape from '../shapes/ScrollableOrientationShape';
import DayOfWeekShape from '../shapes/DayOfWeekShape';
import { HORIZONTAL_ORIENTATION, VERTICAL_ORIENTATION, VERTICAL_SCROLLABLE, DAY_SIZE } from '../constants';
var MONTH_PADDING = 23;
var DAY_PICKER_PADDING = 9;
var PREV_TRANSITION = 'prev';
var NEXT_TRANSITION = 'next';
var propTypes = {
  // calendar presentation props
  enableOutsideDays: types.bool,
  numberOfMonths: types.number,
  orientation: ScrollableOrientationShape,
  withPortal: types.bool,
  onOutsideClick: types.func,
  hidden: types.bool,
  initialVisibleMonth: types.func,
  firstDayOfWeek: DayOfWeekShape,
  renderCalendarInfo: types.func,
  hideKeyboardShortcutsPanel: types.bool,
  keyboardShortcutsCloseButton: types.node,
  daySize: nonNegativeInteger,
  isRTL: types.bool,
  // navigation props
  navPrev: types.node,
  navNext: types.node,
  onPrevMonthClick: types.func,
  onNextMonthClick: types.func,
  onMultiplyScrollableMonths: types.func,
  // month props
  renderMonth: types.func,
  // day props
  modifiers: types.object,
  renderDay: types.func,
  onClick: types.func,
  onMouseEnter: types.func,
  onMouseLeave: types.func,
  // accessibility props
  isFocused: types.bool,
  getFirstFocusableDay: types.func,
  onBlur: types.func,
  showKeyboardShortcuts: types.bool,
  monthFormat: types.string,
  dateIsUnavailableLabel: types.string,
  keyboardShortcutLabels: types.shape(getPhraseTypes(DayPickerKeyboardShortcutsPhrases)),
  navigationLabels: types.shape(getPhraseTypes(DayPickerNavigationPhrases)),
  styles: types.func,
  padding: types.number,
  paddingBottom: types.number,
  monthPadding: types.number
};
export var defaultProps = {
  // calendar presentation props
  enableOutsideDays: false,
  numberOfMonths: 2,
  orientation: HORIZONTAL_ORIENTATION,
  withPortal: false,
  onOutsideClick: function onOutsideClick() {},
  hidden: false,
  initialVisibleMonth: function initialVisibleMonth() {
    return moment();
  },
  firstDayOfWeek: moment.localeData().firstDayOfWeek(),
  hideKeyboardShortcutsPanel: false,
  daySize: DAY_SIZE,
  isRTL: false,
  // navigation props
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onMultiplyScrollableMonths: function onMultiplyScrollableMonths() {},
  // day props
  modifiers: {},
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  // accessibility props
  isFocused: false,
  onBlur: function onBlur() {},
  showKeyboardShortcuts: false,
  monthFormat: 'MMMM YYYY',
  padding: DAY_PICKER_PADDING,
  paddingBottom: MONTH_PADDING
};

function applyTransformStyles(el, transform) {
  var _context;

  var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var transformStyles = getTransformStyles(transform);
  transformStyles.opacity = opacity;

  _forEachInstanceProperty(_context = _Object$keys(transformStyles)).call(_context, function (styleKey) {
    // eslint-disable-next-line no-param-reassign
    el.style[styleKey] = transformStyles[styleKey];
  });
}

export var calculateDimension = function calculateDimension(el, axis) {
  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!el) {
    return 0;
  }

  var axisStart = axis === 'width' ? 'Left' : 'Top';
  var axisEnd = axis === 'width' ? 'Right' : 'Bottom';
  var style = !borderBox || withMargin ? window.getComputedStyle(el) : undefined;
  var offsetWidth = el.offsetWidth,
      offsetHeight = el.offsetHeight;
  var size = axis === 'width' ? offsetWidth : offsetHeight;

  if (!borderBox) {
    size -= _parseFloat(style["padding".concat(axisStart)]) + _parseFloat(style["padding".concat(axisEnd)]) + _parseFloat(style["border".concat(axisStart, "Width")]) + _parseFloat(style["border".concat(axisEnd, "Width")]);
  }

  if (withMargin) {
    size += _parseFloat(style["margin".concat(axisStart)]) + _parseFloat(style["margin".concat(axisEnd)]);
  }

  return size;
};

function getMonthHeight(el) {
  var caption = el.querySelector('[data-type="caption"]');
  var grid = el.querySelector('[data-type="grid"]'); // Need to separate out table children for FF
  // Add an additional +1 for the border

  return calculateDimension(caption, 'height', true, true) + calculateDimension(grid, 'height') + 1;
}

export var DayPicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DayPicker, _React$Component);

  var _super = _createSuper(DayPicker);

  function DayPicker(props) {
    var _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11;

    var _this;

    _classCallCheck(this, DayPicker);

    _this = _super.call(this, props);
    var currentMonth = props.hidden ? moment() : props.initialVisibleMonth();
    var focusedDate = currentMonth.clone().startOf('month');

    if (props.getFirstFocusableDay) {
      focusedDate = props.getFirstFocusableDay(currentMonth);
    }

    var translationValue = props.isRTL && _this.isHorizontal() ? -getCalendarMonthWidth(props.daySize, props.monthPadding) : 0;
    _this.hasSetInitialVisibleMonth = !props.hidden;
    _this.state = {
      currentMonth: currentMonth,
      monthTransition: undefined,
      translationValue: translationValue,
      scrollableMonthMultiple: 1,
      calendarMonthWidth: getCalendarMonthWidth(props.daySize, props.monthPadding),
      focusedDate: !props.hidden || props.isFocused ? focusedDate : undefined,
      nextFocusedDate: undefined,
      showKeyboardShortcuts: props.showKeyboardShortcuts,
      onKeyboardShortcutsPanelClose: function onKeyboardShortcutsPanelClose() {},
      isTouchDevice: isTouchDevice(),
      withMouseInteractions: true
    };
    _this.onKeyDown = _bindInstanceProperty(_context2 = _this.onKeyDown).call(_context2, _assertThisInitialized(_this));
    _this.onPrevMonthClick = _bindInstanceProperty(_context3 = _this.onPrevMonthClick).call(_context3, _assertThisInitialized(_this));
    _this.onNextMonthClick = _bindInstanceProperty(_context4 = _this.onNextMonthClick).call(_context4, _assertThisInitialized(_this));
    _this.setCalendarMonthGridRef = _bindInstanceProperty(_context5 = _this.setCalendarMonthGridRef).call(_context5, _assertThisInitialized(_this));
    _this.multiplyScrollableMonths = _bindInstanceProperty(_context6 = _this.multiplyScrollableMonths).call(_context6, _assertThisInitialized(_this));
    _this.updateStateAfterMonthTransition = _bindInstanceProperty(_context7 = _this.updateStateAfterMonthTransition).call(_context7, _assertThisInitialized(_this));
    _this.openKeyboardShortcutsPanel = _bindInstanceProperty(_context8 = _this.openKeyboardShortcutsPanel).call(_context8, _assertThisInitialized(_this));
    _this.closeKeyboardShortcutsPanel = _bindInstanceProperty(_context9 = _this.closeKeyboardShortcutsPanel).call(_context9, _assertThisInitialized(_this));
    _this.maybeTransitionPrevMonth = _bindInstanceProperty(_context10 = _this.maybeTransitionPrevMonth).call(_context10, _assertThisInitialized(_this));
    _this.maybeTransitionNextMonth = _bindInstanceProperty(_context11 = _this.maybeTransitionNextMonth).call(_context11, _assertThisInitialized(_this));
    return _this;
  }

  _createClass(DayPicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isTouchDevice: isTouchDevice()
      });

      if (this.isHorizontal()) {
        this.adjustDayPickerHeight();
        this.initializeDayPickerWidth();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var hidden = nextProps.hidden,
          isFocused = nextProps.isFocused,
          showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
          onBlur = nextProps.onBlur;
      var currentMonth = this.state.currentMonth;

      if (!hidden) {
        if (!this.hasSetInitialVisibleMonth) {
          this.hasSetInitialVisibleMonth = true;
          this.setState({
            currentMonth: nextProps.initialVisibleMonth()
          });
        }

        if (!this.dayPickerWidth && this.isHorizontal()) {
          this.initializeDayPickerWidth();
          this.adjustDayPickerHeight();
        }
      }

      if (nextProps.daySize !== this.props.daySize) {
        this.setState({
          calendarMonthWidth: getCalendarMonthWidth(nextProps.daySize, nextProps.monthPadding)
        });
      }

      if (isFocused !== this.props.isFocused) {
        if (isFocused) {
          var focusedDate = this.getFocusedDay(currentMonth);
          var onKeyboardShortcutsPanelClose = nextProps.showKeyboardShortcuts ? onBlur : this.state.onKeyboardShortcutsPanelClose;
          this.setState({
            showKeyboardShortcuts: showKeyboardShortcuts,
            onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
            focusedDate: focusedDate,
            withMouseInteractions: false
          });
        } else {
          this.setState({
            focusedDate: undefined
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state = this.state,
          monthTransition = _this$state.monthTransition,
          currentMonth = _this$state.currentMonth,
          focusedDate = _this$state.focusedDate;

      if (monthTransition || !currentMonth.isSame(prevState.currentMonth)) {
        if (this.isHorizontal()) {
          this.adjustDayPickerHeight();
        }
      }

      if (!prevProps.isFocused && this.props.isFocused && !focusedDate || !prevProps.showKeyboardShortcuts && this.props.showKeyboardShortcuts) {
        this.container.focus();
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _this2 = this;

      e.stopPropagation();
      this.setState({
        withMouseInteractions: false
      });
      var onBlur = this.props.onBlur;
      var _this$state2 = this.state,
          focusedDate = _this$state2.focusedDate,
          showKeyboardShortcuts = _this$state2.showKeyboardShortcuts;
      if (!focusedDate) return; // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
      // return it to wherever it was before when the panel was opened

      var activeElement = getActiveElement();

      var onKeyboardShortcutsPanelClose = function onKeyboardShortcutsPanelClose() {
        if (activeElement) activeElement.focus();
      };

      var handleKey = function handleKey(method) {
        return function (fn) {
          return function (date, e) {
            typeof e.preventdefault === 'function' && e.preventDefault();
            var focusedDate = fn(date);

            if (!method(focusedDate)) {
              _this2.setState({
                focusedDate: focusedDate
              });
            }
          };
        };
      };

      var handleKeyPrev = handleKey(this.maybeTransitionPrevMonth);
      var handleKeyNext = handleKey(this.maybeTransitionNextMonth);

      var addOne = function addOne(period) {
        return handleKeyNext(function (date) {
          return date.add(1, period);
        });
      };

      var subtractOne = function subtractOne(period) {
        return handleKeyPrev(function (date) {
          return date.subtract(1, period);
        });
      };

      var startOf = function startOf(period) {
        return handleKeyPrev(function (date) {
          return date.startOf(period);
        });
      };

      var endOf = function endOf(period) {
        return handleKeyNext(function (date) {
          return date.endOf(period);
        });
      };

      var keyHandlers = {
        ArrowRight: addOne('day'),
        ArrowDown: addOne('week'),
        PageDown: addOne('month'),
        ArrowLeft: subtractOne('day'),
        ArrowUp: subtractOne('week'),
        PageUp: subtractOne('month'),
        Home: startOf('week'),
        End: endOf('week'),
        '?': function _() {
          return _this2.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
        },
        Escape: function Escape() {
          return showKeyboardShortcuts ? _this2.closeKeyboardShortcutsPanel() : onBlur();
        }
      };

      if (keyHandlers.hasOwnProperty(e.key)) {
        keyHandlers[e.key](focusedDate.clone(), e);
      }
    }
  }, {
    key: "onPrevMonthClick",
    value: function onPrevMonthClick(nextFocusedDate, e) {
      var isRTL = this.props.isRTL;
      if (e) e.preventDefault();
      var translationValue = this.isVertical() ? this.getMonthHeightByIndex(0) : this.dayPickerWidth;

      if (isRTL && this.isHorizontal()) {
        translationValue = -2 * this.dayPickerWidth;
      } // The first CalendarMonth is always positioned absolute at top: 0 or left: 0
      // so we need to transform it to the appropriate location before the animation.
      // This behavior is because we would otherwise need a double-render in order to
      // adjust the container position once we had the height the first calendar
      // (ie first draw all the calendar, then in a second render, use the first calendar's
      // height to position the container). Variable calendar heights, amirite? <3 Maja


      this.translateFirstDayPickerForAnimation(translationValue);
      this.setState({
        monthTransition: PREV_TRANSITION,
        translationValue: translationValue,
        focusedDate: undefined,
        nextFocusedDate: nextFocusedDate
      });
    }
  }, {
    key: "onNextMonthClick",
    value: function onNextMonthClick(nextFocusedDate, e) {
      var isRTL = this.props.isRTL;
      if (e) e.preventDefault();
      var translationValue = this.isVertical() ? -this.getMonthHeightByIndex(1) : -this.dayPickerWidth;

      if (isRTL && this.isHorizontal()) {
        translationValue = 0;
      }

      this.setState({
        monthTransition: NEXT_TRANSITION,
        translationValue: translationValue,
        focusedDate: undefined,
        nextFocusedDate: nextFocusedDate
      });
    }
  }, {
    key: "getFocusedDay",
    value: function getFocusedDay(newMonth) {
      var _this$props = this.props,
          getFirstFocusableDay = _this$props.getFirstFocusableDay,
          numberOfMonths = _this$props.numberOfMonths;
      var focusedDate;

      if (getFirstFocusableDay) {
        focusedDate = getFirstFocusableDay(newMonth);
      }

      if (newMonth && (!focusedDate || !isDayVisible(focusedDate, newMonth, numberOfMonths))) {
        focusedDate = newMonth.clone().startOf('month');
      }

      return focusedDate;
    }
  }, {
    key: "getMonthHeightByIndex",
    value: function getMonthHeightByIndex(i) {
      if (!this.transitionContainer) return;
      return getMonthHeight(this.transitionContainer.querySelectorAll('[data-type="month"]')[i]);
    }
  }, {
    key: "setCalendarMonthGridRef",
    value: function setCalendarMonthGridRef(ref) {
      this.calendarMonthGrid = ref;
    }
  }, {
    key: "maybeTransitionMonth",
    value: function maybeTransitionMonth(newFocusedDate, handler) {
      var numberOfMonths = this.props.numberOfMonths;
      var _this$state3 = this.state,
          currentMonth = _this$state3.currentMonth,
          focusedDate = _this$state3.focusedDate;
      var isNewFocusedDateVisible = isDayVisible(newFocusedDate, currentMonth, numberOfMonths);

      if (newFocusedDate.month() !== focusedDate.month() && !isNewFocusedDateVisible) {
        handler(newFocusedDate);
        return true;
      }

      return false;
    }
  }, {
    key: "maybeTransitionPrevMonth",
    value: function maybeTransitionPrevMonth(newFocusedDate) {
      this.maybeTransitionMonth(newFocusedDate, this.onPrevMonthClick);
    }
  }, {
    key: "maybeTransitionNextMonth",
    value: function maybeTransitionNextMonth(newFocusedDate) {
      this.maybeTransitionMonth(newFocusedDate, this.onNextMonthClick);
    }
  }, {
    key: "multiplyScrollableMonths",
    value: function multiplyScrollableMonths(e) {
      var onMultiplyScrollableMonths = this.props.onMultiplyScrollableMonths;
      if (e) e.preventDefault();
      onMultiplyScrollableMonths(e);
      this.setState({
        scrollableMonthMultiple: this.state.scrollableMonthMultiple + 1
      });
    }
  }, {
    key: "isHorizontal",
    value: function isHorizontal() {
      return this.props.orientation === HORIZONTAL_ORIENTATION;
    }
  }, {
    key: "isVertical",
    value: function isVertical() {
      return this.props.orientation !== HORIZONTAL_ORIENTATION;
    }
  }, {
    key: "initializeDayPickerWidth",
    value: function initializeDayPickerWidth() {
      if (this.calendarMonthGrid) {
        this.dayPickerWidth = calculateDimension(this.calendarMonthGrid.querySelector('[data-type="month"]'), 'width', true);
      }
    }
  }, {
    key: "updateStateAfterMonthTransition",
    value: function updateStateAfterMonthTransition() {
      var _handleTransitions;

      var _this$props2 = this.props,
          onPrevMonthClick = _this$props2.onPrevMonthClick,
          onNextMonthClick = _this$props2.onNextMonthClick;
      var _this$state4 = this.state,
          currentMonth = _this$state4.currentMonth,
          monthTransition = _this$state4.monthTransition,
          focusedDate = _this$state4.focusedDate,
          nextFocusedDate = _this$state4.nextFocusedDate,
          withMouseInteractions = _this$state4.withMouseInteractions;
      if (!monthTransition) return;

      var shiftMonth = function shiftMonth(direction, sideEffect) {
        return function (month) {
          sideEffect();
          return month[direction](1, 'month');
        };
      };

      var handleTransitions = (_handleTransitions = {}, _defineProperty(_handleTransitions, PREV_TRANSITION, shiftMonth('subtract', onPrevMonthClick)), _defineProperty(_handleTransitions, NEXT_TRANSITION, shiftMonth('add', onNextMonthClick)), _handleTransitions);
      var newMonth = handleTransitions[monthTransition](currentMonth.clone());
      var newFocusedDate = nextFocusedDate || !focusedDate && !withMouseInteractions ? this.getFocusedDay(newMonth) : undefined;

      if (this.calendarMonthGrid) {
        // eslint-disable-next-line react/no-find-dom-node
        var calendarMonthGridDOMNode = ReactDOM.findDOMNode(this.calendarMonthGrid);

        if (calendarMonthGridDOMNode) {
          // clear the previous transforms
          applyTransformStyles(calendarMonthGridDOMNode.querySelector('[data-type="month"]'), 'none');
        }
      }

      this.setState({
        currentMonth: newMonth,
        monthTransition: undefined,
        translationValue: this.props.isRTL && this.isHorizontal() ? -this.dayPickerWidth : 0,
        nextFocusedDate: undefined,
        focusedDate: newFocusedDate
      }, function () {
        // we don't want to focus on the relevant calendar day after a month transition
        // if the user is navigating around using a mouse
        if (withMouseInteractions) {
          var activeElement = getActiveElement();

          if (activeElement && activeElement !== document.body) {
            activeElement.blur();
          }
        }
      });
    }
  }, {
    key: "adjustDayPickerHeight",
    value: function adjustDayPickerHeight() {
      if (!this.transitionContainer) return;
      var heights = [];

      _forEachInstanceProperty(Array.prototype).call(this.transitionContainer.querySelectorAll('[data-type="month"]'), function (el) {
        if (el.getAttribute('data-visible') === 'true') {
          heights.push(getMonthHeight(el));
        }
      });

      var newMonthHeight = Math.max.apply(Math, heights) + this.props.paddingBottom;

      if (newMonthHeight !== calculateDimension(this.transitionContainer, 'height')) {
        this.monthHeight = newMonthHeight;
        this.transitionContainer.style.height = "".concat(newMonthHeight, "px");
      }
    }
  }, {
    key: "translateFirstDayPickerForAnimation",
    value: function translateFirstDayPickerForAnimation(translationValue) {
      var _context12;

      var isRTL = this.props.isRTL;
      var convertedTranslationValue = -translationValue;

      if (isRTL && this.isHorizontal()) {
        var positiveTranslationValue = Math.abs(translationValue + this.dayPickerWidth);
        convertedTranslationValue = positiveTranslationValue;
      }

      var transformType = this.isVertical() ? 'translateY' : 'translateX';

      var transformValue = _concatInstanceProperty(_context12 = "".concat(transformType, "(")).call(_context12, convertedTranslationValue, "px)");

      applyTransformStyles(this.transitionContainer.querySelector('[data-type="month"]'), transformValue, 1);
    }
  }, {
    key: "openKeyboardShortcutsPanel",
    value: function openKeyboardShortcutsPanel(onCloseCallBack) {
      this.setState({
        showKeyboardShortcuts: true,
        onKeyboardShortcutsPanelClose: onCloseCallBack
      });
    }
  }, {
    key: "closeKeyboardShortcutsPanel",
    value: function closeKeyboardShortcutsPanel() {
      var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

      if (onKeyboardShortcutsPanelClose) {
        onKeyboardShortcutsPanelClose();
      }

      this.setState({
        onKeyboardShortcutsPanelClose: undefined,
        showKeyboardShortcuts: false
      });
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var _this3 = this;

      var _this$props3 = this.props,
          navPrev = _this$props3.navPrev,
          navNext = _this$props3.navNext,
          orientation = _this$props3.orientation,
          isRTL = _this$props3.isRTL,
          navigationLabels = _this$props3.navigationLabels;
      var onNextMonthClick = orientation === VERTICAL_SCROLLABLE ? this.multiplyScrollableMonths : function (e) {
        _this3.onNextMonthClick(undefined, e);
      };
      return /*#__PURE__*/React.createElement(DayPickerNavigation, {
        onPrevMonthClick: function onPrevMonthClick(e) {
          _this3.onPrevMonthClick(undefined, e);
        },
        onNextMonthClick: onNextMonthClick,
        navPrev: navPrev,
        navNext: navNext,
        orientation: orientation,
        labels: navigationLabels,
        isRTL: isRTL
      });
    }
  }, {
    key: "renderWeekHeader",
    value: function renderWeekHeader(index) {
      var _headerStyle, _context13;

      var _this$props4 = this.props,
          width = _this$props4.daySize,
          orientation = _this$props4.orientation,
          firstDayOfWeek = _this$props4.firstDayOfWeek,
          styles = _this$props4.styles,
          renderWeekDay = _this$props4.renderWeekDay,
          weekDayFormat = _this$props4.weekDayFormat;
      var calendarMonthWidth = this.state.calendarMonthWidth;
      var headerStyle = (_headerStyle = {}, _defineProperty(_headerStyle, HORIZONTAL_ORIENTATION, {
        left: index * calendarMonthWidth,
        width: calendarMonthWidth
      }), _defineProperty(_headerStyle, VERTICAL_ORIENTATION, {
        marginLeft: -calendarMonthWidth / 2,
        width: calendarMonthWidth
      }), _headerStyle);

      var renderHeaderLabel = function renderHeaderLabel(i) {
        var date = moment().day((i + firstDayOfWeek) % 7);
        return /*#__PURE__*/React.createElement("li", {
          key: i,
          style: {
            width: width
          }
        }, renderWeekDay ? renderWeekDay(date) : date.format(weekDayFormat || 'dd'));
      };

      var headerLabels = _mapInstanceProperty(_context13 = [0, 1, 2, 3, 4, 5, 6]).call(_context13, renderHeaderLabel);

      return /*#__PURE__*/React.createElement("ul", _extends({
        key: "week-".concat(index)
      }, styles.with('weekHeader')(headerStyle[orientation])), headerLabels);
    }
  }, {
    key: "render",
    value: function render() {
      var _context14,
          _styles$with,
          _this4 = this;

      var _this$state5 = this.state,
          calendarMonthWidth = _this$state5.calendarMonthWidth,
          currentMonth = _this$state5.currentMonth,
          monthTransition = _this$state5.monthTransition,
          translationValue = _this$state5.translationValue,
          scrollableMonthMultiple = _this$state5.scrollableMonthMultiple,
          focusedDate = _this$state5.focusedDate,
          showKeyboardShortcuts = _this$state5.showKeyboardShortcuts,
          isTouch = _this$state5.isTouchDevice;
      var _this$props5 = this.props,
          enableOutsideDays = _this$props5.enableOutsideDays,
          numberOfMonths = _this$props5.numberOfMonths,
          orientation = _this$props5.orientation,
          modifiers = _this$props5.modifiers,
          withPortal = _this$props5.withPortal,
          onClick = _this$props5.onClick,
          onMouseEnter = _this$props5.onMouseEnter,
          onMouseLeave = _this$props5.onMouseLeave,
          firstDayOfWeek = _this$props5.firstDayOfWeek,
          renderMonth = _this$props5.renderMonth,
          renderDay = _this$props5.renderDay,
          renderCalendarInfo = _this$props5.renderCalendarInfo,
          keyboardShortcutsCloseButton = _this$props5.keyboardShortcutsCloseButton,
          hideKeyboardShortcutsPanel = _this$props5.hideKeyboardShortcutsPanel,
          onOutsideClick = _this$props5.onOutsideClick,
          monthFormat = _this$props5.monthFormat,
          daySize = _this$props5.daySize,
          isFocused = _this$props5.isFocused,
          dateIsUnavailableLabel = _this$props5.dateIsUnavailableLabel,
          keyboardShortcutLabels = _this$props5.keyboardShortcutLabels,
          styles = _this$props5.styles,
          padding = _this$props5.padding,
          monthPadding = _this$props5.monthPadding;
      var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
      var weekHeaders = [];

      for (var i = 0; i < numOfWeekHeaders; i += 1) {
        weekHeaders.push(this.renderWeekHeader(i));
      }

      var firstVisibleMonthIndex = 1;

      if (monthTransition === PREV_TRANSITION) {
        firstVisibleMonthIndex -= 1;
      } else if (monthTransition === NEXT_TRANSITION) {
        firstVisibleMonthIndex += 1;
      }

      var verticalScrollable = this.props.orientation === VERTICAL_SCROLLABLE;
      if (verticalScrollable) firstVisibleMonthIndex = 0;
      var horizontalWidth = calendarMonthWidth * numberOfMonths + 2 * padding; // this is a kind of made-up value that generally looks good. we'll
      // probably want to let the user set this explicitly.

      var verticalHeight = 1.75 * calendarMonthWidth;
      var dayPickerStyle = {
        width: this.isHorizontal() && horizontalWidth,
        // These values are to center the datepicker (approximately) on the page
        marginLeft: this.isHorizontal() && withPortal && -horizontalWidth / 2,
        marginTop: this.isHorizontal() && withPortal && -calendarMonthWidth / 2
      };
      var transitionContainerStyle = {
        width: this.isHorizontal() && horizontalWidth,
        height: this.isVertical() && !verticalScrollable && !withPortal && verticalHeight
      };
      var isCalendarMonthGridAnimating = !!monthTransition;
      var transformType = this.isVertical() ? 'translateY' : 'translateX';

      var transformValue = _concatInstanceProperty(_context14 = "".concat(transformType, "(")).call(_context14, translationValue, "px)");

      var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;
      var keyboardShortcutButtonLocation = BOTTOM_RIGHT;

      if (this.isVertical()) {
        keyboardShortcutButtonLocation = withPortal ? TOP_LEFT : TOP_RIGHT;
      }

      return /*#__PURE__*/React.createElement("div", styles.with((_styles$with = {
        container: true
      }, _defineProperty(_styles$with, orientation, true), _defineProperty(_styles$with, "withPortal", withPortal), _styles$with))(dayPickerStyle), /*#__PURE__*/React.createElement(OutsideClickHandler, {
        onOutsideClick: onOutsideClick
      }, /*#__PURE__*/React.createElement("div", _extends({}, styles('headers'), {
        "aria-hidden": "true",
        role: "presentation"
      }), weekHeaders), /*#__PURE__*/React.createElement("div", _extends({}, styles('region'), {
        ref: function ref(_ref2) {
          _this4.container = _ref2;
        },
        onClick: function onClick(e) {
          e.stopPropagation();
        },
        onKeyDown: throttle(this.onKeyDown, 300),
        onMouseUp: function onMouseUp() {
          _this4.setState({
            withMouseInteractions: true
          });
        },
        role: "region",
        tabIndex: -1
      }), !verticalScrollable && this.renderNavigation(), /*#__PURE__*/React.createElement("div", _extends({}, styles.with(_defineProperty({
        transition: true
      }, "transition_".concat(orientation), true))(transitionContainerStyle), {
        ref: function ref(_ref) {
          _this4.transitionContainer = _ref;
        }
      }), /*#__PURE__*/React.createElement(CalendarMonthGrid, {
        setRef: this.setCalendarMonthGridRef,
        transformValue: transformValue,
        enableOutsideDays: enableOutsideDays,
        firstVisibleMonthIndex: firstVisibleMonthIndex,
        initialMonth: currentMonth,
        isAnimating: isCalendarMonthGridAnimating,
        modifiers: modifiers,
        orientation: orientation,
        numberOfMonths: numberOfMonths * scrollableMonthMultiple,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        renderMonth: renderMonth,
        renderDay: renderDay,
        onMonthTransitionEnd: this.updateStateAfterMonthTransition,
        monthFormat: monthFormat,
        daySize: daySize,
        firstDayOfWeek: firstDayOfWeek,
        isFocused: shouldFocusDate,
        focusedDate: focusedDate,
        dateIsUnavailableLabel: dateIsUnavailableLabel,
        padding: padding,
        monthPadding: monthPadding
      }), verticalScrollable && this.renderNavigation()), !isTouch && !hideKeyboardShortcutsPanel && /*#__PURE__*/React.createElement(DayPickerKeyboardShortcuts, {
        block: this.isVertical() && !withPortal,
        buttonLocation: keyboardShortcutButtonLocation,
        showKeyboardShortcutsPanel: showKeyboardShortcuts,
        openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
        closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
        labels: keyboardShortcutLabels,
        closeButton: keyboardShortcutsCloseButton
      })), renderCalendarInfo && renderCalendarInfo()));
    }
  }]);

  return DayPicker;
}(React.Component);
DayPicker.propTypes = propTypes;
DayPicker.defaultProps = defaultProps;
export default styled(styles)(DayPicker);